// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"a49926cc","879":"9d949080"}[chunkId] + ".chunk.js";
};